import { BsCheckCircleFill } from "react-icons/bs"

const CardOptions = ({ active, title, description, icon, onClick }: { active?: boolean, title?: string, description?: string, icon?: React.ReactNode, onClick?: () => void }) => {
    return (
        <div
            className={`group relative overflow-hidden rounded-2xl border-2 transition-all duration-300 p-3 cursor-pointer flex items-center gap-3 ${active ? "border-blue-500 bg-blue-50/50 shadow-lg shadow-blue-100 -translate-y-1" : "border-slate-100 bg-white hover:border-blue-200 hover:shadow-md"}`}
            onClick={onClick}
        >

            <div className={`p-3 rounded-xl transition-colors duration-300 ${active ? "bg-blue-500 text-white shadow-lg shadow-blue-200" : "bg-slate-50 text-slate-400 shadow shadow-blue-200 group-hover:bg-blue-50 group-hover:text-blue-500"}`}>
                {icon}
            </div>
            <div>
                <div className={`text-lg font-bold transition-colors duration-300 ${active ? "text-blue-900" : "text-slate-700"}`}> {title} </div>
                <div className={`text-sm leading-relaxed transition-colors duration-300 ${active ? "text-blue-700/80" : "text-slate-500"}`}>{description}</div>
            </div>
            {active && (
                <div className="text-blue-500 absolute top-3 right-2 transition-all duration-300">
                    <BsCheckCircleFill size={24} />
                </div>
            )}
        </div>
    )
}

export default CardOptions